import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { useConsultation } from "../components/Consultation";
import { LineReveal, Reveal, SolidButton } from "../components/Shared";
import { IMAGES } from "../data/content";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  const { open } = useConsultation();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="always-dark relative flex min-h-[90vh] items-center overflow-hidden" data-testid="final-cta-section">
      <motion.img src={IMAGES.cta} alt="Make an entrance — Rutu Bhonsle" loading="lazy" className="absolute inset-0 h-[120%] w-full object-cover" style={{ y }} />
      <div className="absolute inset-0 bg-ink/80" />
      <div className="relative mx-auto w-full max-w-[1600px] px-5 py-28 sm:px-10">
        <LineReveal
          lines={["READY TO MAKE", "AN ENTRANCE?"]}
          className="font-serif text-[13vw] font-light leading-[0.95] tracking-tight sm:text-[10vw] lg:text-[8vw]"
          lineClassName="last:text-flame"
        />
        <Reveal delay={0.3}>
          <p className="mt-8 max-w-md text-lg font-light text-bone/80">Let's create something that feels unmistakably you.</p>
        </Reveal>
        <Reveal delay={0.45} className="mt-12 flex flex-wrap items-center gap-6">
          <Link to="/shop" data-testid="final-shop-button" className="group inline-flex items-center gap-3 border border-bone/40 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-bone transition-all duration-300 hover:border-flame hover:text-flame">
            Shop the Edit <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" />
          </Link>
          <SolidButton onClick={open} testId="final-consultation-button">Book a Consultation</SolidButton>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
